import SongPlayer from '@/shared/Players/SongPlayer/SongPlayer';
import { StyledSongActivity } from './SongActivity.styled';
import useSongActivity from './useSongActivity.hook';
import Image from 'next/image';
import KaraokePlayer from '@/shared/Players/KaraokePlayer/KaraokePlayer';
import useMediaActivityProgress from '../SimpleMediaActivities/useMediaActivityProgress';
import AnimatedStars from '@/shared/StudentPage/StudentPageTopbar/GamificationScoreBoard/AnimatedStars/AnimatedStars';
import { ANCHOR } from '@/modules/dom/getElementCoordinates';
import useActivitySEO from '../useActivitySEO.hook';

export default function SongActivity({
  activity,
  taskProgressActions,
  forceRestart,
}) {
  const { state: songState } = useSongActivity({
    activity,
    taskProgressActions,
  });

  const { state: mediaState, actions: progressAPIActions } =
    useMediaActivityProgress({
      activity,
      taskProgressActions,
    });

  const { actions: seoActions } = useActivitySEO({ activity });

  const state = { ...songState, ...mediaState };

  return (
    <StyledSongActivity
      className={`${taskProgressActions ? 'with-image' : ''} ${
        taskProgressActions ? 'with-image' : ''
      }`}
    >
      <AnimatedStars
        originSelector=".ant-progress-success-bg"
        originAnchor={ANCHOR.RIGHT}
      />
      <div className="activity-content">
        {!activity.data?.karaokeCues &&
          state.showLyrics &&
          state.lyricsImage?.src && (
            <div className="lyric-image">
              <Image
                src={state.lyricsImage.src}
                layout="responsive"
                width={state.lyricsImage.width}
                height={state.lyricsImage.height}
                priority
                alt="lyric-image"
              />
            </div>
          )}
        {activity.data?.karaokeCues ? (
          <KaraokePlayer
            className="karaoke-player"
            url={activity.data?.file}
            sourceImage={activity.data?.karaokeLyrics}
            cues={activity.data?.karaokeCues}
            onReady={progressAPIActions.onReady}
            onStart={() => {
              progressAPIActions.onStart();
              seoActions.onStart();
            }}
            onProgress={(progressData) => {
              progressAPIActions.onProgress(progressData);
              seoActions.onMediaProgress({ progressData });
            }}
            onRestart={() => {
              progressAPIActions.onRestart();
              seoActions.reset();
              seoActions.onStart();
            }}
            forceRestart={forceRestart}
            noSeek={state.noSeek}
            canIncreasePlaybackRate={!taskProgressActions}
            translations={activity.data?.translations}
          />
        ) : (
          <div className="song-player-wrapper">
            <SongPlayer
              url={activity.data?.file}
              onReady={progressAPIActions.onReady}
              onStart={() => {
                progressAPIActions.onStart();
                seoActions.onStart();
              }}
              onProgress={(progressData) => {
                progressAPIActions.onProgress(progressData);
                seoActions.onMediaProgress({ progressData });
              }}
              onRestart={() => {
                progressAPIActions.onRestart();
                seoActions.onStart();
              }}
              forceRestart={forceRestart}
              noSeek={state.noSeek}
              progressInterval={state.activityProgressInterval}
            />
          </div>
        )}
      </div>
    </StyledSongActivity>
  );
}
